import { type Namespace, type ParseKeys, type TFunction } from 'i18next';
import { type Language } from '@pkgs/api';

type CountTranslationOptions = {
  count: number;
};

export const formatWithCount = <TNamespace extends Namespace>(
  t: TFunction<TNamespace>,
  key: ParseKeys<TNamespace>,
  count: number,
): string => {
  const translateWithCount = t as (key: ParseKeys<TNamespace>, options: CountTranslationOptions) => string;

  return `${translateWithCount(key, { count })}${count > 1 ? ` (${count})` : ''}`;
};

export const joinWithSeparator = (arr: Array<string | undefined>, separator = ' \u00B7 '): string => arr.filter(Boolean).join(separator);

export const formatDate = (date: string, language: Language): string => {
  return new Date(date).toLocaleString(language, {
    year: 'numeric',
    month: 'long',
  });
};
